import React from 'react';
import Image from 'next/image';

interface Props {
  steps: any;
  state: any;
  onBack: () => void;
}
const Navigation = ({ steps, onBack, state }: Props) => {
  return (
    <div className="grid grid-cols-2 w-full items-center">
      <div className="flex">
        {steps[state.currentStep].hasPrev && (
          <button
            type="button"
            aria-label="go back in onboarding"
            className="text-white justify-self-start"
            data-dd-action-name="back"
            onClick={onBack}
            data-test-id="onboarding back"
          >
            <Image
              src="/back.svg"
              alt="close language settings modal"
              height={48}
              width={48}
            />
          </button>
        )}
      </div>
      <p
        data-test-id="onboarding-steps-count"
        className="text-white justify-self-end h-[48px] flex justify-center items-center"
      >
        {state.currentStep + 1} of {state.totalSteps}
      </p>
    </div>
  );
};

export default Navigation;
